import React, { forwardRef } from 'react';

import { type PopupComponentProps } from '@atlaskit/popup';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

const popupStyles = xcss({
	zIndex: '1',
	backgroundColor: 'color.background.neutral.subtle',
});

const PopupComponent = forwardRef<HTMLDivElement, PopupComponentProps>(
	({ 'data-testid': testId, ...props }, ref) => (
		<Box {...props} ref={ref} xcss={popupStyles} testId={testId} />
	),
);

export default PopupComponent;
